<template>
    <div class="m-riddle">
        <div class="title"></div>
        <div class="slogen"></div>
        
        <div class="riddle-view">
            <div class="riddle-item r-1" @click="$skin_modal({active : 0})" :class="{'open' : step >= 1 , 'act' : evt_info.uflag == 1 || evt_info.uflag == 11}">
                <div class="bubble" v-if="step >= 1"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[0] }}%</p>
                </div>
            </div>
            <div class="riddle-item r-2" @click="$skin_modal({active : 1})" :class="{'open' : step >= 2 , 'act' : evt_info.uflag == 2 || evt_info.uflag == 12}">
                <div class="bubble" v-if="step >= 2"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[1] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-3" @click="$skin_modal({active : 2})" :class="{'open' : step >= 3 , 'act' : evt_info.uflag == 3 || evt_info.uflag == 13}">
                <div class="bubble" v-if="step >= 3"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[2] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-4" @click="$skin_modal({active : 3})" :class="{'open' : step >= 4 , 'act' : evt_info.uflag == 4 || evt_info.uflag == 14}">
                <div class="bubble" v-if="step >= 4"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[3] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-5" @click="$skin_modal({active : 4})" :class="{'open' : step >= 5 , 'act' : evt_info.uflag == 5 || evt_info.uflag == 15}">
                <div class="bubble" v-if="step >= 5"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[4] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-6" @click="$skin_modal({active : 5})" :class="{'open' : step >= 6 , 'act' : evt_info.uflag == 6 || evt_info.uflag == 16} ">
                <div class="bubble" v-if="step >= 6"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[5] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-7" @click="$skin_modal({active : 6})" :class="{'open' : step >= 7 , 'act' : evt_info.uflag == 7 || evt_info.uflag == 17}">
                <div class="bubble" v-if="step >= 7"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[6] }}%</p>
                </div>                
            </div>
            <div class="riddle-item r-8" @click="$skin_modal({active : 7})" :class="{'open' : step >= 8 , 'act' : evt_info.uflag == 8 || evt_info.uflag == 18}">
                <div class="bubble" v-if="step >= 8"></div>

                <div class="text">
                    <p>嫌疑程度</p>
                    <p>{{ today_list[7] }}%</p>
                </div>                
            </div>
        </div>

        <div class="m-user">
            <userinfo :login_flag="login" :info="ua"/>

            <div class="tips-view">
                <div class="tips-item tips-1"></div>
                <div class="tips-item tips-2">
                    <div class="u-btn u-share" @click="call_share"></div>
                </div>
            </div>                      
        </div>

        <div class="u-btn rule" @click="$rule_modal()"></div>

        <div class="u-btn u-vote" @click="call_vote"></div>
    </div>
</template>

<style scoped>
.title{
    width: 558px;
    height: 180px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/title-1.png);
}

.slogen{
    width: 1150px;
    height: 96px;
    margin: -30px auto 15px;
    background-image: url(~@/assets/images/pc/slogen-1.png);   
}

.u-btn.rule{
    width: 111px;
    height: 26px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/btn-rule.png);    
}

.m-user{
    position: relative;
    width: 1390px;
    margin: 0 auto 35px;
    text-align: center;
}

.tips-view{
    position: absolute;
    right: 0;
    top: -30px;    
}

.tips-item{
    position: relative;   
    width: 346px;
    height: 37px;
    margin-bottom: 5px;
    
}

.tips-item.tips-1{
    background-image: url(~@/assets/images/pc/tips-1.png); 
}

.tips-item.tips-2{
    background-image: url(~@/assets/images/pc/tips-2.png); 
}

.tips-item .u-share{
    position: absolute;
    right: 5px;
    top: 50%;
    width: 95px;
    height: 35px;
    transform: translateY(-50%);
    background-image: url(~@/assets/images/pc/btn-share.png); 
}

.u-vote{
    width: 321px;
    height: 77px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/btn-vote.png); 
}

.riddle-view{
    display: flex;
    justify-content: space-evenly;
    width: 1390px;
    margin: 40px auto 10px;
}

.riddle-item{
    position: relative;
    /* width: 145px;
    height: 505px;
    background-color: #333; */
    cursor: pointer;
    transition: all .3s ease-in-out;
}

.riddle-item:hover{
    transform: translateY(-20px);
}

.riddle-item.r-1{
    width: 171px;
    height: 524px;
    background-image: url(~@/assets/images/pc/voteItem/normal/1.png); 
}

.riddle-item.r-1.open{
    background-image: url(~@/assets/images/pc/voteItem/open/1.png); 
}

.riddle-item.r-1.act{
    background-image: url(~@/assets/images/pc/voteItem/act/1.png)!important; 
}

.riddle-item.r-2{
    width: 171px;
    height: 532px;
    margin-top: 85px;
    background-image: url(~@/assets/images/pc/voteItem/normal/2.png); 
}

.riddle-item.r-2.open{
    background-image: url(~@/assets/images/pc/voteItem/open/2.png); 
}

.riddle-item.r-2.act{
    background-image: url(~@/assets/images/pc/voteItem/act/2.png)!important; 
}

.riddle-item.r-3{
    width: 147px;
    height: 457px;
    margin-top: 100px;
    background-image: url(~@/assets/images/pc/voteItem/normal/3.png);
    z-index: 3;
}

.riddle-item.r-3.open{
    background-image: url(~@/assets/images/pc/voteItem/open/3.png); 
}

.riddle-item.r-3.act{
    background-image: url(~@/assets/images/pc/voteItem/act/3.png)!important; 
}

.riddle-item.r-4{
    width: 171px;
    height: 532px;
    margin-top: 10px;
    background-image: url(~@/assets/images/pc/voteItem/normal/4.png);
    z-index: 2;
}

.riddle-item.r-4.act{
    background-image: url(~@/assets/images/pc/voteItem/act/4.png)!important; 
}

.riddle-item.r-4.open{
    background-image: url(~@/assets/images/pc/voteItem/open/4.png); 
}

.riddle-item.r-5{
    width: 183px;
    height: 586px;
    margin-top: -30px;
    background-image: url(~@/assets/images/pc/voteItem/normal/5.png); 
}

.riddle-item.r-5.open{
    background-image: url(~@/assets/images/pc/voteItem/open/5.png); 
}

.riddle-item.r-5.act{
    background-image: url(~@/assets/images/pc/voteItem/act/5.png)!important; 
}

.riddle-item.r-6{
    width: 144px;
    height: 502px;
    margin-top: 70px;
    background-image: url(~@/assets/images/pc/voteItem/normal/6.png);
    z-index: 2;
}

.riddle-item.r-6.open{
    background-image: url(~@/assets/images/pc/voteItem/open/6.png); 
}

.riddle-item.r-6.act{
    background-image: url(~@/assets/images/pc/voteItem/act/6.png)!important; 
}

.riddle-item.r-7{
    width: 163px;
    height: 583px;
    margin-top: -20px;
    background-image: url(~@/assets/images/pc/voteItem/normal/7.png); 
}

.riddle-item.r-7.open{
    background-image: url(~@/assets/images/pc/voteItem/open/7.png); 
}

.riddle-item.r-7.act{
    background-image: url(~@/assets/images/pc/voteItem/act/7.png)!important; 
}

.riddle-item.r-8{
    width: 183px;
    height: 546px;
    margin-top: 10px;
    background-image: url(~@/assets/images/pc/voteItem/normal/8.png); 
}

.riddle-item.r-8.open{
    background-image: url(~@/assets/images/pc/voteItem/open/8.png); 
}

.riddle-item.r-8.act{
    background-image: url(~@/assets/images/pc/voteItem/act/8.png)!important; 
}

.riddle-item .text{
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    font-size: 18px;
    font-weight: 700;
    color: #f2edd9;
    text-align: center;
}


.riddle-item .bubble{
    display: none;
    position: absolute;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    background-repeat: no-repeat;
    z-index: 10;
}

.riddle-item:hover .bubble{
    display: block;
}

.riddle-item.r-1 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/1.png); 
}

.riddle-item.r-2 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/2.png); 
}

.riddle-item.r-3 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/3.png);
}

.riddle-item.r-4 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/4.png);
}

.riddle-item.r-5 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/5.png); 
}

.riddle-item.r-6 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/6.png); 
}

.riddle-item.r-7 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/7.png); 
}

.riddle-item.r-8 .bubble{
    width: 239px;
    height: 192px;
    background-image: url(~@/assets/images/pc/vote/bubble/8.png); 
}
</style>

<script>
import userinfo from '@/components/userinfo';
import miscList from '@/assets/js/misc.js';

export default {
    components: {
        userinfo
    },
    data (){
        return {
            day_parse : 0,
            misc_list : miscList,
            today_list : [],
            time_diff : 0,
        }
    },
    props : {
        ready : {
            default : false,
        },
        login : {
            default : 0,
        },      
        ua : {
            default : () => {},
        },
        evt_info : {
            default : () => {},
        },                        
    },
    computed : {
        step (){

            if(!this.login)return 0;

            var step_default = 2;
            if(this.evt_info.uflag >= 10){
                step_default += 2;
            }

            var day_buff = Math.min(this.day_parse,3);

            step_default += 2*day_buff;

            return step_default;
        },
    },
    created (){
        let time_diff = Math.max(0, +new Date() - this.$global.startTime);
        //let time_diff = 0;

        this.time_diff = time_diff;

        this.day_parse = Math.floor(time_diff/(24*60*60*1000));

        this.today_list = this.misc_list[Math.min(this.day_parse,8)];
    },
    methods : {
        call_vote (){
            let vm = this;

            if(!this.ua.uid){
                return this.$mslogin.open();
            }

            if(!this.ua.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            let base = typeof this.evt_info.uflag == 'undefined' ? 0 : this.evt_info.uflag;

            let _active = base > 10 ? (base - 10) : base;

            this.$vote_modal({active : _active,uflag : base});
        },
        call_share (){
            let vm = this;

            if(!this.ua.uid){
                return this.$mslogin.open();
            }

            if(!this.ua.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            vm.$axios.post(globalThis.ajax_url_map.share_apply,{})
            .then(
                res => {
                    this.$update_userType();
                    this.$share_modal({text : res.data.koudai + res.data.surl});
                },
                rej => {
                    //TEST
                    
                }
            )   
        },
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/page/riddle.vue